// Constants for keys of persisted data saved in browser storage.
// Maybe in the future could make keys more random, because stuff might break
// if some outdated and incompatible object is retrieved from storage.
export enum PERSISTENCE_KEY {
  DataState = 'data_state',
  Locale = 'locale',
  MapState = 'map_state',
  PaneLayout = 'pane_layout',
  PropertyPanelExpandedRows = 'property_panel_expanded_rows',
  PropertyPanelSortAlphabetically = 'property_panel_sort_alphabetically',
  PropertyPanelRefineNames = 'property_panel_refine_names',
  ProjectId = 'project_id',
  Region = 'region',
  RightPanelSize = 'mobile-mapping-right-panel-size',
  RightTabName = 'mobile-mapping-right-tab-name',
  SelectedSidePanelTab = 'mobile-mapping-selected-side-panel-tab',
  SidePanelSize = 'mobile-mapping-side-panel-size',
  SlopeMeasurementSettings = 'slope-measurement-settings',
  Theme = 'trimble-theme',
  ThemeSettings = 'theme_settings',
  ViewerPreferenceSettings = 'viewer_preference_settings',
  VisiblePointClouds = 'visible_point_clouds',
  VisibleTrajectories = 'visible_trajectories',
  VisibleModels = 'visible_models',
  Experiments = 'experiments',
  FxActiveWorkspace = 'fx_active_workspace',
  Web3dSettings = 'web3d_settings',
}
